(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[117],{

/***/ 55670:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ captureUnderscoreErrorException; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66465);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92642);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63699);



/** Platform-agnostic version of `flush` */
function flush(timeout) {
  const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  return client ? client.flush(timeout) : Promise.resolve(false);
}

/**
 * Capture the exception passed by nextjs to the `_error` page, adding context data as appropriate.
 *
 * @param contextOrProps The data passed to either `getInitialProps` or `render` by nextjs
 */
async function captureUnderscoreErrorException(contextOrProps) {
  const { req, res, err } = contextOrProps;

  // 404s (and other 400-y friends) can trigger `_error`, but we don't want to send them to Sentry
  const statusCode = (res && res.statusCode) || contextOrProps.statusCode;
  if (statusCode && statusCode < 500) {
    return Promise.resolve();
  }

  // In previous versions of the suggested `_error.js` page in which this function is meant to be used, there was a
  // workaround for https://github.com/vercel/next.js/issues/8592 which involved an extra call to this function, in the
  // custom error component's `render` method, just in case it hadn't been called by `getInitialProps`. Now that that
  // issue has been fixed, the second call is unnecessary, but since it lives in user code rather than our code, users
  // have to be the ones to get rid of it, and guaraneteedly, not all of them will. So, rather than capture the error
  // twice, we just bail if we sense we're in that now-extraneous second call. (We can tell which function we're in
  // because Nextjs passes `pathname` to `getInitialProps` but not to `render`.)
  if (!contextOrProps.pathname) {
    return Promise.resolve();
  }

  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .withScope */ .$e)(scope => {
    scope.addEventProcessor(event => {
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .addExceptionMechanism */ .EG)(event, {
        type: 'instrument',
        handled: false,
        data: {
          function: '_error.getInitialProps',
        },
      });
      return event;
    });

    if (req) {
      scope.setSDKProcessingMetadata({ request: req });
    }

    // If third-party libraries (or users themselves) throw something falsy, we want to capture it as a message (which
    // is what passing a string to `captureException` will wind up doing)
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb)(err || `_error.js called with falsy error (${err})`);
  });

  // In case this is being run as part of a serverless function (as is the case with the server half of nextjs apps
  // deployed to vercel), make sure the error gets sent to Sentry before the lambda exits.
  await flush(2000);
}


//# sourceMappingURL=_error.js.map


/***/ }),

/***/ 11883:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/inbox",
      function () {
        return __webpack_require__(86883);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 36457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Header": function() { return /* binding */ Header; },
/* harmony export */   "Logo": function() { return /* binding */ Logo; },
/* harmony export */   "default": function() { return /* binding */ ErrorPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80684);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55670);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(92642);
/* harmony import */ var nanoid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(37164);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(89961);
/* harmony import */ var _components_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79743);
/* harmony import */ var _constants_events__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26654);
/* harmony import */ var _constants_storageKeys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87183);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30438);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86879);
/* harmony import */ var _utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61216);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  border-bottom: ",
        "px solid ",
        ";\n  display: flex;\n  height: ",
        "px;\n  justify-content: flex-start;\n  left: 0;\n  padding: 0 ",
        "px;\n  position: relative;\n  width: 100%;\n  z-index: ",
        ";\n  @media (max-width: 767px) {\n    height: ",
        "px;\n    justify-content: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  height: 100%;\n  left: ",
        "px;\n\n  a {\n    display: block;\n  }\n\n  img {\n    display: block;\n    max-height: ",
        "px;\n    max-width: 200px;\n  }\n\n  @media (max-width: 767px) {\n    img {\n      max-height: ",
        "px;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n  align-items: center;\n  font-family: "Arial", "Helvetica", sans-serif;\n  display: flex;\n  height: calc(100vh - ',
        "px);\n  justify-content: center;\n  padding: ",
        "px;\n  text-align: center;\n\n  ",
        "\n\n  @media (max-width: 767px) {\n    height: calc(100vh - ",
        "px);\n  }\n\n  a {\n    color: #000;\n    text-decoration: underline;\n\n    &:hover {\n      opacity: 0.9;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var Header = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].nav.withConfig */ .ZP.nav.withConfig({
    componentId: "sc-2b1e0755-0"
})(_templateObject(), _koala_sdk__WEBPACK_IMPORTED_MODULE_2__/* .fallbackConfig.header.background_color */ .fC.header.background_color, _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.NAV_BOTTOM_BORDER_WEIGHT */ ._.NAV_BOTTOM_BORDER_WEIGHT, _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .COLORS.GRAY */ .DM.GRAY, _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.HEADERHEIGHT */ ._.HEADERHEIGHT, _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.GUTTER */ ._.GUTTER, _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .ORDER.HEADER */ .kl.HEADER, _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.MOBILE_HEADERHEIGHT */ ._.MOBILE_HEADERHEIGHT);
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2b1e0755-1"
})(_templateObject1(), _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.GUTTER */ ._.GUTTER, _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.HEADERHEIGHT */ ._.HEADERHEIGHT - _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.GUTTER */ ._.GUTTER / 2, _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.MOBILE_HEADERHEIGHT */ ._.MOBILE_HEADERHEIGHT - _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.GUTTER */ ._.GUTTER / 2);
var StyledError = styled_components__WEBPACK_IMPORTED_MODULE_11__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2b1e0755-2"
})(_templateObject2(), _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.HEADERHEIGHT */ ._.HEADERHEIGHT * 2, _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.GUTTER */ ._.GUTTER, function(param) {
    var isFixed = param.isFixed;
    return isFixed && "\n    background: white;\n    left: 0;\n    height: 100%;\n    position: fixed;\n    top: 0;\n    width: 100%;\n    z-index: ".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .ORDER.HEADER */ .kl.HEADER, ";\n  ");
}, _constants_styles__WEBPACK_IMPORTED_MODULE_8__/* .LAYOUT.MOBILE_HEADERHEIGHT */ ._.MOBILE_HEADERHEIGHT * 2);
/**
 * Attempts to retrieve session details from sessionStorage.
 * If none are present, it initializes a new session.
 * @TODO this should be integrated into KoalaAnalytics.
 */ function getSessionDetails() {
    var sessionId = window.sessionStorage.getItem(_constants_storageKeys__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_KEYS.SESSION_ID */ .s.SESSION_ID);
    var sessionStart = window.sessionStorage.getItem(_constants_storageKeys__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_KEYS.SESSION_START */ .s.SESSION_START);
    if (sessionId && sessionStart) {
        return {
            sessionId: sessionId,
            sessionStart: sessionStart
        };
    }
    sessionId = (0,nanoid__WEBPACK_IMPORTED_MODULE_12__/* .nanoid */ .x0)();
    sessionStart = new Date().toISOString();
    window.sessionStorage.setItem(_constants_storageKeys__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_KEYS.SESSION_ID */ .s.SESSION_ID, sessionId);
    window.sessionStorage.setItem(_constants_storageKeys__WEBPACK_IMPORTED_MODULE_7__/* .SESSION_STORAGE_KEYS.SESSION_START */ .s.SESSION_START, sessionStart);
    return {
        sessionId: sessionId,
        sessionStart: sessionStart
    };
}
/**
 * This page is loaded by NextJS
 *  - on the server, when data-fetching methods throw or reject
 *  - on the client, when `getInitialProps` throws or rejects
 *  - on the client, when a React lifecycle method throws or rejects, and it's
 *    caught by the built-in Nextjs error boundary
 *
 * @see https://nextjs.org/docs/basic-features/data-fetching/overview
 * @see  https://nextjs.org/docs/api-reference/data-fetching/get-initial-props
 * @see  https://reactjs.org/docs/error-boundaries.html
 */ function ErrorPage(param) {
    var statusCode = param.statusCode;
    var ref = (0,_redux__WEBPACK_IMPORTED_MODULE_9__/* .useSelector */ .v9)(function(state) {
        return state.app.organization.organization;
    }), label = ref.label, id = ref.id;
    /**
   * This Sentry call compensates for an issue in Next.JS prior to 12.2.1.
   * @see https://github.com/vercel/next.js/issues/8592
   * @TODO remove this after upgrading to Next@13
   */ void _sentry_nextjs__WEBPACK_IMPORTED_MODULE_13__/* .captureUnderscoreErrorException */ .u({
        statusCode: statusCode
    });
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        var ref = getSessionDetails(), sessionId = ref.sessionId, sessionStart = ref.sessionStart;
        try {
            // Ensure the KoalaAnalytics class is always created on app load
            if (!window.KoalaAnalytics) {
                window.KoalaAnalytics = new _utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP(sessionId, sessionStart, id, label);
            }
            // Fire KA event
            (0,_utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_10__/* .fireKAnalyticsEvent */ .G)(_constants_events__WEBPACK_IMPORTED_MODULE_6__/* .K_ANALYTICS_EVENTS.ERROR */ .AH.ERROR, {
                name: _constants_events__WEBPACK_IMPORTED_MODULE_6__/* .ERROR_MESSAGES.APPLICATION_ERROR */ .RZ.APPLICATION_ERROR,
                details: "Status code: ".concat(statusCode, ". Href: ").concat(window.location.href, ".")
            });
        } catch (e) {
            _sentry_nextjs__WEBPACK_IMPORTED_MODULE_14__/* .captureException */ .Tb(e, {
                level: "error",
                extra: {
                    message: "Failed to fire Koala Analytics Error Page event"
                }
            });
        }
    }, [
        label,
        statusCode
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Header, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Logo, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_image__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                            alt: label,
                            // @ts-expect-error ensure that header.logo is defined in the fallbackConfig.
                            src: _koala_sdk__WEBPACK_IMPORTED_MODULE_2__/* .fallbackConfig.header.logo */ .fC.header.logo,
                            height: 40,
                            objectFit: "contain",
                            width: 120
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledError, {
                isFixed: !statusCode,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                            children: [
                                "Error ",
                                statusCode
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                            children: statusCode === 404 ? "Sorry, we couldn't find anything here." : "Sorry, something went wrong. Try refreshing or go back to the homepage below."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            href: "/",
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                children: "Go to homepage"
                            })
                        })
                    ]
                })
            })
        ]
    });
}
ErrorPage.getInitialProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(function(ctx) {
        var ref, ref1, statusCode;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_16__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    // Pass the exception to Sentry.
                    return [
                        4,
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_13__/* .captureUnderscoreErrorException */ .u(ctx)
                    ];
                case 1:
                    _state.sent();
                    statusCode = 404;
                    if ((ref = ctx.res) === null || ref === void 0 ? void 0 : ref.statusCode) {
                        statusCode = ctx.res.statusCode;
                    }
                    if ((ref1 = ctx.err) === null || ref1 === void 0 ? void 0 : ref1.statusCode) {
                        statusCode = ctx.err.statusCode;
                    }
                    return [
                        2,
                        {
                            statusCode: statusCode
                        }
                    ];
            }
        });
    });
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 86883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ InboxPage; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/components/uielements/primaryButton/styles.tsx
var styles = __webpack_require__(25167);
// EXTERNAL MODULE: ./src/constants/styles.ts
var constants_styles = __webpack_require__(30438);
// EXTERNAL MODULE: ./src/redux/cmsConfig/utils.ts
var utils = __webpack_require__(73393);
;// CONCATENATED MODULE: ./src/components/account/inbox/expandedMessage/styles.ts




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: 767px) {\n    display: flex;\n    flex-direction: row-reverse;\n    justify-content: space-between;\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  background: none;\n  cursor: pointer;\n  font-size: 32px;\n  height: 100%;\n  line-height: normal;\n  padding: 0;\n\n  img {\n    height: 24px;\n    width: 24px;\n  }\n\n  @media (max-width: 767px) {\n    padding-right: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (min-width: 768px) {\n    display: none;\n  }\n\n  @media (max-width: 767px) {\n    padding: 0 0 0 ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  a {\n    margin-bottom: ",
        "px;\n  }\n\n  @media (min-width: 768px) {\n    display: flex;\n    justify-content: start;\n\n    a {\n      margin: 0 ",
        "px 0 0;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: visible;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var _border_color, _border_radius, _border_radius1, _background_color, _background_color1;
var StyledExpandedMessageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e27a588d-0"
})(function(param) {
    var theme = param.theme, backgroundImage = param.backgroundImage;
    var _obj;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        border: "solid 1px ".concat((_border_color = theme.auth_page.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        borderRadius: "".concat((_border_radius = theme.auth_page.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px ").concat((_border_radius1 = theme.auth_page.border_radius) !== null && _border_radius1 !== void 0 ? _border_radius1 : 0, "px 0 0"),
        height: "calc(100vh - ".concat(constants_styles/* LAYOUT.HEADERHEIGHT */._.HEADERHEIGHT, "px - ").concat(constants_styles/* LAYOUT.LOYALTY_MENU_HEIGHT_DESKTOP */._.LOYALTY_MENU_HEIGHT_DESKTOP, "px - ").concat(constants_styles/* LAYOUT.GUTTER */._.GUTTER, "px)"),
        overflowY: "scroll",
        position: "absolute",
        right: "20px",
        top: "20px",
        width: "calc(".concat(constants_styles/* LAYOUT.MAX_LOYALTY_CONTAINER_WIDTH */._.MAX_LOYALTY_CONTAINER_WIDTH, "px - 35% - ").concat(constants_styles/* LAYOUT.GUTTER */._.GUTTER * 2, "px)"),
        zIndex: "".concat(constants_styles/* ORDER.LOYALTY_HEADER */.kl.LOYALTY_HEADER - 1),
        "-webkit-overflow-scrolling": "touch"
    }, (0,utils/* getFontStyles */.l)(theme.auth_page.font)), (_obj = {
        "> div": {
            background: (_background_color = theme.auth_page.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
            padding: "20px"
        },
        "@media (min-width: 768px)": {
            backgroundImage: backgroundImage ? "url(".concat(backgroundImage, ")") : "none",
            padding: backgroundImage ? "20px" : 0
        }
    }, (0,_define_property/* default */.Z)(_obj, "@media (max-width: ".concat(constants_styles/* LAYOUT.MAX_LOYALTY_CONTAINER_WIDTH */._.MAX_LOYALTY_CONTAINER_WIDTH, "px)"), {
        width: "calc(100% - 35% - ".concat(constants_styles/* LAYOUT.GUTTER */._.GUTTER * 2, "px)")
    }), (0,_define_property/* default */.Z)(_obj, "@media (max-width: 767px)", {
        background: (_background_color1 = theme.auth_page.background_color) !== null && _background_color1 !== void 0 ? _background_color1 : "transparent",
        borderRadius: 0,
        height: "calc(\n        100vh - ".concat(constants_styles/* LAYOUT.MOBILE_HEADERHEIGHT */._.MOBILE_HEADERHEIGHT, "px -\n          ").concat(constants_styles/* LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE */._.LOYALTY_MENU_HEIGHT_MOBILE, "px\n      )"),
        position: "fixed",
        top: "calc(\n        ".concat(constants_styles/* LAYOUT.MOBILE_HEADERHEIGHT */._.MOBILE_HEADERHEIGHT, "px + ").concat(constants_styles/* LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE */._.LOYALTY_MENU_HEIGHT_MOBILE, "px\n        )"),
        right: 0,
        width: "100%",
        "> div": {
            padding: "10px 10px 120px"
        }
    }), _obj));
});
var StyledExpandedMessageHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e27a588d-1"
})(function(param) {
    var theme = param.theme;
    return {
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        position: "relative",
        h1: (0,_object_spread/* default */.Z)({
            margin: 0
        }, (0,utils/* getFontStyles */.l)(theme.auth_page.secondary_font)),
        "@media (max-width: 767px)": {
            display: "block"
        }
    };
});
var StyledExpandedMessageBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e27a588d-2"
})(function(param) {
    var theme = param.theme;
    return {
        marginTop: "20px",
        "p, h4": (0,_object_spread/* default */.Z)({}, (0,utils/* getFontStyles */.l)(theme.auth_page.font, [
            "color",
            "font_family",
            "font_style",
            "line_height", 
        ])),
        p: {
            margin: "0 0 20px"
        },
        h4: {
            fontSize: "16px",
            fontFamily: theme.primary_font.bold.font_family
        },
        "img, video": {
            maxWidth: "100%"
        }
    };
});
var StyledMessageIcons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e27a588d-3"
})(_templateObject());
var StyledMessageIcon = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-e27a588d-4"
})(_templateObject1(), constants_styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledCloseMessageIcon = (0,styled_components_browser_esm/* default */.ZP)(StyledMessageIcon).withConfig({
    componentId: "sc-e27a588d-5"
})(_templateObject2(), constants_styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledButtonContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e27a588d-6"
})(_templateObject3(), constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER * 2);
var StyledMessageCtas = (0,styled_components_browser_esm/* default */.ZP)(styles/* StyledPrimaryButton */.D).withConfig({
    componentId: "sc-e27a588d-7"
})(_templateObject4());

// EXTERNAL MODULE: ./src/components/account/loyaltyAccessor/index.tsx
var loyaltyAccessor = __webpack_require__(51319);
// EXTERNAL MODULE: ./src/components/uielements/X/index.tsx
var X = __webpack_require__(66086);
// EXTERNAL MODULE: ./src/constants/loyalty.ts
var loyalty = __webpack_require__(92106);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var actions = __webpack_require__(47290);
// EXTERNAL MODULE: ./src/utils/loyalty.ts
var utils_loyalty = __webpack_require__(53174);
;// CONCATENATED MODULE: ./src/components/account/inbox/expandedMessage/index.tsx













var ExpandedMessage = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ExpandedMessage, Component);
    var _super = (0,_create_super/* default */.Z)(ExpandedMessage);
    function ExpandedMessage() {
        (0,_class_call_check/* default */.Z)(this, ExpandedMessage);
        return _super.apply(this, arguments);
    }
    var _proto = ExpandedMessage.prototype;
    _proto.render = function render() {
        var _this = this;
        var ref, ref1, ref2, ref3, ref4;
        var _props = this.props, closeMessage = _props.closeMessage, message = _props.message;
        // Split message body into lines
        var parsedMessageBody = message.body.split("\n");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledExpandedMessageContainer, {
            backgroundImage: message === null || message === void 0 ? void 0 : (ref = message.background_content) === null || ref === void 0 ? void 0 : ref.url,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledExpandedMessageHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMessageIcons, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCloseMessageIcon, {
                                        onClick: function() {
                                            return closeMessage();
                                        },
                                        "aria-label": "Click to close this message",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(X/* XSvg */.Ji, {})
                                    }),
                                    message.type !== loyalty/* LOYALTY_MESSAGE_TYPES.BUSINESS */.GA.BUSINESS && /*#__PURE__*/ (0,jsx_runtime.jsx)(loyaltyAccessor/* default */.Z, {
                                        checkType: loyalty/* LOYALTY_ACCESSOR_TYPES.FEATURE */.Mo.FEATURE,
                                        checkName: loyalty/* LOYALTY_FEATURES.DESTROY_LOYALTY_MESSAGE */.lw.DESTROY_LOYALTY_MESSAGE,
                                        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMessageIcon, {
                                            onClick: function() {
                                                return _this.props.deleteMessage(message.id);
                                            },
                                            "aria-label": "Click to delete this message",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/static/img/icons/delete.png",
                                                alt: "Delete Icon",
                                                role: "presentation"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: message.title
                            })
                        ]
                    }),
                    message.launch_time && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            margin: 0
                        },
                        children: (0,utils_loyalty/* dateFormatter */.vh)(message.launch_time)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledExpandedMessageBody, {
                        children: [
                            ((ref1 = message.hero_content) === null || ref1 === void 0 ? void 0 : ref1.url) && (message.hero_content.type === loyalty/* MESSAGE_HERO_TYPES.VIDEO */.$e.VIDEO ? /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                src: (ref2 = message.hero_content) === null || ref2 === void 0 ? void 0 : ref2.url,
                                controls: true
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (ref3 = message.hero_content) === null || ref3 === void 0 ? void 0 : ref3.url,
                                alt: (ref4 = message.hero_content) === null || ref4 === void 0 ? void 0 : ref4.alt_text
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: message.subtitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: parsedMessageBody.map(function(line, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: line.trim()
                                    }, "line-".concat(index));
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonContainer, {
                                children: message.message_ctas.filter(function(cta) {
                                    return cta.type !== loyalty/* MESSAGE_CTA_TYPES.DRILL_DOWN */.$r.DRILL_DOWN;
                                }).map(function(cta, index) {
                                    // TODO: improve this type and remove string type to narrow it to proper union type
                                    // Second CTA will be knockout theme
                                    var buttonTheme = index === 1 ? "knockout" : "";
                                    if (cta.type === loyalty/* MESSAGE_CTA_TYPES.DEEP_LINK */.$r.DEEP_LINK) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: (0,utils_loyalty/* routePunchhDeepLinks */.yI)(cta),
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMessageCtas, {
                                                buttonTheme: buttonTheme,
                                                as: "a",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: cta.label
                                                })
                                            })
                                        }, index);
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMessageCtas, {
                                        buttonTheme: buttonTheme,
                                        as: "a",
                                        href: cta.url,
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: cta.label
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            })
        });
    };
    return ExpandedMessage;
}(react.Component);
var mapDispatchToProps = {
    deleteMessage: actions/* default.deleteMessage */.Z.deleteMessage
};
var connector = (0,es.connect)(null, mapDispatchToProps);
/* harmony default export */ var expandedMessage = (connector(ExpandedMessage));

;// CONCATENATED MODULE: ./src/components/account/inbox/messageList/styles.ts



function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  border-left: solid 4px ",
        ";\n  cursor: pointer;\n  display: flex;\n  overflow: hidden;\n  margin-bottom: ",
        "px;\n  padding: ",
        "px;\n  text-align: left;\n  width: 35%;\n\n  &:last-child {\n    margin-bottom: 0px;\n  }\n\n  @media (max-width: 767px) {\n    margin: ",
        "px;\n    padding: ",
        "px;\n    width: calc(100% - ",
        "px);\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: ",
        "px;\n  position: relative;\n\n  ",
        "\n\n  @media (max-width: 767px) {\n    margin-right: ",
        "px;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  object-fit: cover;\n  height: 72px;\n  width: 72px;\n\n  @media (max-width: 767px) {\n    width: 48px;\n    height: 48px;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledMessagePreview = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-8a135d86-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    background: ".concat(theme.location_card.background_color, ";\n    border: solid 1px ").concat(theme.location_card.border_color, ";\n    border-radius: ").concat(theme.location_card.border_radius, "px;\n  ");
}, function(param) {
    var activeMessage = param.activeMessage, theme = param.theme;
    return activeMessage ? theme.global.primary_active_color : theme.location_card.border_color;
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2, constants_styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledPreviewText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a135d86-1"
})(function(param) {
    var theme = param.theme, messageRead = param.messageRead;
    return {
        h3: (0,_object_spread/* default */.Z)({
            display: "-webkit-box",
            margin: "0 0 10px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical"
        }, (0,utils/* getFontStyles */.l)(theme.location_card.secondary_font, {
            font_weight: function() {
                return messageRead ? 400 : 900;
            }
        })),
        p: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            display: "-webkit-box",
            margin: "0 0 10px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 3,
            WebkitBoxOrient: "vertical"
        }, (0,utils/* getFontStyles */.l)(theme.location_card.font)), {
            "&:last-child": {
                marginBottom: "0px"
            }
        })
    };
});
var StyledCroppedImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8a135d86-2"
})(styles_templateObject1(), constants_styles/* LAYOUT.GUTTER */._.GUTTER, function(param) {
    var isUnread = param.isUnread, theme = param.theme;
    return isUnread && "\n    &:after {\n      content: '';\n      width: 16px;\n      height: 16px;\n      background: ".concat(theme.global.primary_active_color, ";\n      border-radius: 50%;\n      border: solid 2px ").concat(constants_styles/* COLORS.WHITE */.DM.WHITE, ";\n      position: absolute;\n      top: -5px;\n      right: -5px;\n    }\n  ");
}, constants_styles/* LAYOUT.GUTTER */._.GUTTER / 2);
var StyledCroppedImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-8a135d86-3"
})(styles_templateObject2(), function(param) {
    var theme = param.theme;
    return "\n    border: 1px solid ".concat(theme.auth_page.border_color, ";\n    border-radius: ").concat(theme.auth_page.border_radius, "px;\n  ");
});

// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
;// CONCATENATED MODULE: ./src/components/account/inbox/messageList/index.tsx










var MessageList = function() {
    var ref = (0,react.useState)(null), activeMessage = ref[0], setActiveMessage = ref[1];
    var messages = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me;
    }).messages;
    var dispatch = (0,es.useDispatch)();
    (0,react.useEffect)(function() {
        // Only default load a message on desktop
        if (!window.matchMedia("(max-width: 767px)").matches) {
            var messageToActivate = messages === null || messages === void 0 ? void 0 : messages[0];
            if (!messageToActivate) {
                return;
            }
            setActiveMessage(messageToActivate);
            if (!(messageToActivate === null || messageToActivate === void 0 ? void 0 : messageToActivate.read_at)) {
                dispatch(actions/* default.markMessageAsRead */.Z.markMessageAsRead(messageToActivate.id));
            }
        }
    }, []);
    var openMessage = function(message) {
        setActiveMessage(message);
        // If mobile, lock body scroll on expanded message
        if (window.matchMedia("(max-width: 767px)").matches) {
            (0,global/* toggleBodyScroll */.R0)(!message);
        }
        // Mark message as read
        if (!message.read_at) {
            dispatch(actions/* default.markMessageAsRead */.Z.markMessageAsRead(message.id));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: messages === null || messages === void 0 ? void 0 : messages.map(function(message) {
            var ref, ref1, ref2, ref3, ref4;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMessagePreview, {
                        "aria-label": "Click to read message",
                        onClick: function() {
                            return openMessage(message);
                        },
                        activeMessage: (activeMessage === null || activeMessage === void 0 ? void 0 : activeMessage.id) === message.id,
                        children: [
                            ((ref = message.hero_content) === null || ref === void 0 ? void 0 : ref.url) && ((ref1 = message.hero_content) === null || ref1 === void 0 ? void 0 : ref1.type) === loyalty/* MESSAGE_HERO_TYPES.IMAGE */.$e.IMAGE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCroppedImageContainer, {
                                // Only display the 'unread' dot on message if personal message
                                isUnread: (message === null || message === void 0 ? void 0 : message.type) === loyalty/* LOYALTY_MESSAGE_TYPES.PERSONAL */.GA.PERSONAL && !message.read_at,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCroppedImage, {
                                    src: (ref2 = message.hero_content) === null || ref2 === void 0 ? void 0 : ref2.url,
                                    // @ts-expect-error TODO SDK
                                    alt: (ref3 = message.hero) === null || ref3 === void 0 ? void 0 : ref3.alt_text
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPreviewText, {
                                messageRead: Boolean(message.read_at) || message.type === loyalty/* LOYALTY_MESSAGE_TYPES.BUSINESS */.GA.BUSINESS,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: message.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: message.subtitle || ((ref4 = message.body) === null || ref4 === void 0 ? void 0 : ref4.substring(0, 200))
                                    }),
                                    message.launch_time && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: (0,utils_loyalty/* dateFormatter */.vh)(message.launch_time)
                                    })
                                ]
                            })
                        ]
                    }, message.id),
                    (activeMessage === null || activeMessage === void 0 ? void 0 : activeMessage.id) === message.id && /*#__PURE__*/ (0,jsx_runtime.jsx)(expandedMessage, {
                        message: message,
                        closeMessage: function() {
                            return setActiveMessage(null);
                        }
                    })
                ]
            }, message.id);
        })
    });
};

// EXTERNAL MODULE: ./src/components/account/styles.ts
var account_styles = __webpack_require__(99736);
;// CONCATENATED MODULE: ./src/components/account/inbox/styles.tsx



function inbox_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n\n  @media (min-width: 768px) {\n    overflow-y: scroll;\n    padding: ",
        "px;\n  }\n"
    ]);
    inbox_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function inbox_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: calc(\n    100vh - ",
        "px - ",
        "px -\n      ",
        "px\n  );\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n\n  @media (max-width: 767px) {\n    height: auto;\n    min-height: calc(\n      100vh - ",
        "px -\n        ",
        "px\n    );\n    padding-bottom: ",
        "px;\n  }\n"
    ]);
    inbox_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var StyledInboxContainer = (0,styled_components_browser_esm/* default */.ZP)(account_styles/* StyledLoyaltyContainer */.t9).withConfig({
    componentId: "sc-35c91017-0"
})(inbox_styles_templateObject(), constants_styles/* LAYOUT.GUTTER */._.GUTTER);
var StyledMessagesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35c91017-1"
})(inbox_styles_templateObject1(), constants_styles/* LAYOUT.HEADERHEIGHT */._.HEADERHEIGHT, constants_styles/* LAYOUT.LOYALTY_MENU_HEIGHT_DESKTOP */._.LOYALTY_MENU_HEIGHT_DESKTOP, constants_styles/* LAYOUT.GUTTER */._.GUTTER, constants_styles/* LAYOUT.MOBILE_HEADERHEIGHT */._.MOBILE_HEADERHEIGHT, constants_styles/* LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE */._.LOYALTY_MENU_HEIGHT_MOBILE, constants_styles/* LAYOUT.GUTTER */._.GUTTER);
var styles_border_color, styles_border_radius;
var StyledEmptyMessagesContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-35c91017-2"
})(function(param) {
    var theme = param.theme;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "center",
        border: "1px solid ".concat((styles_border_color = theme.auth_page.border_color) !== null && styles_border_color !== void 0 ? styles_border_color : "transparent"),
        borderRadius: "".concat((styles_border_radius = theme.auth_page.border_radius) !== null && styles_border_radius !== void 0 ? styles_border_radius : 0, "px"),
        display: "flex",
        height: "100%",
        margin: "20px",
        justifyContent: "center",
        padding: "20px",
        textAlign: "center"
    }, (0,utils/* getFontStyles */.l)(theme.auth_page.font)), {
        "@media (max-width: 767px)": {
            margin: "10px"
        }
    });
});

// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
;// CONCATENATED MODULE: ./src/components/account/inbox/index.tsx




function Inbox(param) {
    var messages = param.messages;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInboxContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMessagesContainer, {
            children: (messages === null || messages === void 0 ? void 0 : messages.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageList, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledEmptyMessagesContainer, {
                children: (messages === null || messages === void 0 ? void 0 : messages.length) === 0 ? // No messages
                /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                    accessor: "inbox.empty_state",
                    html: true,
                    tag: "span"
                }) : // Loading messages
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Loading messages..."
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/app/layout/index.tsx + 110 modules
var layout = __webpack_require__(37356);
// EXTERNAL MODULE: ./src/components/restrict/index.tsx
var restrict = __webpack_require__(40129);
// EXTERNAL MODULE: ./src/redux/me/use-account.ts
var use_account = __webpack_require__(9455);
// EXTERNAL MODULE: ./src/utils/auth.ts + 1 modules
var auth = __webpack_require__(10606);
;// CONCATENATED MODULE: ./pages/account/inbox/index.tsx








function InboxPage() {
    var ref = (0,use_account/* useAccountDispatch */.U)(), dispatch = ref.dispatch, fetchMessages = ref.fetchMessages;
    var messages = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.me.messages;
    });
    (0,react.useEffect)(function() {
        if ((0,auth/* userLoggedIn */.nD)()) {
            dispatch(fetchMessages());
        }
    }, [
        dispatch,
        fetchMessages
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(restrict/* RestrictedAccountRoute */.Q, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
            backgroundOverride: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inbox, {
                messages: messages
            })
        })
    });
}


/***/ }),

/***/ 99736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$3": function() { return /* binding */ StyledContactInfoContainer; },
/* harmony export */   "Dk": function() { return /* binding */ StyledInlineCancelAndSubmitButtons; },
/* harmony export */   "Gq": function() { return /* binding */ StyledForm; },
/* harmony export */   "JP": function() { return /* binding */ StyledTopLevelLoyaltyContainer; },
/* harmony export */   "Ji": function() { return /* binding */ StyledContactInfoContent; },
/* harmony export */   "Ll": function() { return /* binding */ StyledFormField; },
/* harmony export */   "Mo": function() { return /* binding */ StyledCancelEdit; },
/* harmony export */   "Pw": function() { return /* binding */ StyledFlexedHeader; },
/* harmony export */   "Qu": function() { return /* binding */ StyledSecondarySection; },
/* harmony export */   "UN": function() { return /* binding */ StyledLinkButton; },
/* harmony export */   "VX": function() { return /* binding */ StyledCancelAndSubmitButtons; },
/* harmony export */   "aN": function() { return /* binding */ StyledAccountContainer; },
/* harmony export */   "fb": function() { return /* binding */ StyledInlineFormContainer; },
/* harmony export */   "t9": function() { return /* binding */ StyledLoyaltyContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-3);\n  padding-top: var(--size-3);\n\n  @media (min-width: 768px) {\n    gap: var(--size-6);\n    padding-top: var(--size-6);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto;\n  max-width: ",
        "px;\n  padding: ",
        "px 0;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: ",
        "px;\n  margin: ",
        "px auto 0;\n\n  @media (max-width: 767px) {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  justify-content: space-between;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  // to ensure first component never goes behind the loyalty nav\n  margin-top: ",
        "px;\n\n  @media (max-width: 767px) {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1 1 33.333%;\n  height: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  &:not(:first-child) {\n    padding-left: ",
        "px;\n\n    @media (max-width: 767px) {\n      padding-left: 0;\n    }\n  }\n\n  @media (max-width: 767px) {\n    flex-basis: 100%;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: right;\n  align-self: flex-end;\n\n  @media (max-width: 767px) {\n    display: flex;\n    flex-direction: column-reverse;\n    width: 100%;\n    margin: 0;\n\n    button {\n      width: 100%;\n    }\n\n    > div:first-child {\n      margin: ",
        "px 0 0 0;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  top: -20px;\n\n  @media (max-width: 767px) {\n    top: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: ",
        "px;\n\n  p {\n    margin: ",
        "px 0;\n    font-size: 16px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  @media (max-width: 767px) {\n    display: block;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  margin-right: ",
        "px;\n  align-items: center;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-size: 16px;\n  color: ",
        ";\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n\n  &:hover {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var StyledAccountContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-0"
})(_templateObject());
var StyledSecondarySection = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-1"
})(_templateObject1(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MAX_LOYALTY_CONTAINER_WIDTH */ ._.MAX_LOYALTY_CONTAINER_WIDTH, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER * 2);
var StyledLoyaltyContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-2"
})(_templateObject2(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MAX_LOYALTY_CONTAINER_WIDTH */ ._.MAX_LOYALTY_CONTAINER_WIDTH, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_DESKTOP */ ._.LOYALTY_MENU_HEIGHT_DESKTOP, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE */ ._.LOYALTY_MENU_HEIGHT_MOBILE);
var StyledFlexedHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-3"
})(_templateObject3());
var StyledTopLevelLoyaltyContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-4"
})(_templateObject4(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_DESKTOP */ ._.LOYALTY_MENU_HEIGHT_DESKTOP, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.LOYALTY_MENU_HEIGHT_MOBILE */ ._.LOYALTY_MENU_HEIGHT_MOBILE);
var StyledForm = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].form.withConfig */ .ZP.form.withConfig({
    componentId: "sc-495d45f5-5"
})(_templateObject5());
var StyledInlineFormContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-6"
})(_templateObject6());
var StyledFormField = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-7"
})(_templateObject7(), function(param) {
    var autoHeight = param.autoHeight, theme = param.theme;
    return autoHeight ? "auto" : "".concat(theme.forms.field_height + _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER, "px");
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledCancelAndSubmitButtons = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-8"
})(_templateObject8(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledInlineCancelAndSubmitButtons = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(StyledCancelAndSubmitButtons).withConfig({
    componentId: "sc-495d45f5-9"
})(_templateObject9());
var StyledContactInfoContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-10"
})(_templateObject10(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER / 4);
var StyledContactInfoContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-11"
})(_templateObject11());
var StyledCancelEdit = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-495d45f5-12"
})(_templateObject12(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.GUTTER */ ._.GUTTER);
var StyledLinkButton = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-495d45f5-13"
})(_templateObject13(), function(param) {
    var bold = param.bold, theme = param.theme;
    return bold ? theme.primary_font.bold.font_family : theme.primary_font.regular.font_family;
}, function(param) {
    var theme = param.theme;
    return theme.global.primary_active_color;
});


/***/ }),

/***/ 40129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ RestrictedAccountRoute; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56580);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25643);
/* harmony import */ var _utils_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10606);
/* harmony import */ var _utils_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36304);
/* harmony import */ var _utils_loyalty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53174);
/* harmony import */ var pages_error__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36457);









var RestrictedAccountRoute = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showContent = ref[0], setShowContent = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var loyaltyDriverID = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__.useSelector)(function(state) {
        return state.app.organization.organization.loyalty_driver_id;
    });
    var currentRoute = router.route;
    var currentRouteAllowed = (0,_utils_loyalty__WEBPACK_IMPORTED_MODULE_7__/* .allowedLoyaltyRoutes */ .kz)(loyaltyDriverID).includes(currentRoute);
    /**
   * Redirect the user to a login screen if loggged out
   */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function redirectIfLoggedOut() {
        if (!(0,_utils_auth__WEBPACK_IMPORTED_MODULE_5__/* .userLoggedIn */ .nD)()) {
            var referrer = (0,_utils_global__WEBPACK_IMPORTED_MODULE_6__/* .deriveReferrer */ .k5)(router);
            void router.push("".concat(_constants_routes__WEBPACK_IMPORTED_MODULE_4__/* .ROUTES.LOGIN */ .Z6.LOGIN, "?referrer=").concat(referrer));
        } else {
            setShowContent(true);
        }
    }, [
        router
    ]);
    if (!showContent) {
        return null;
    }
    if (!currentRouteAllowed) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_error__WEBPACK_IMPORTED_MODULE_8__["default"], {
            statusCode: 404
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};


/***/ }),

/***/ 9455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ useAccountDispatch; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86879);
/* harmony import */ var _redux_me_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47290);



var useAccountDispatch = function() {
    var dispatch = (0,_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        dispatch: dispatch
    }, _redux_me_actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [669,513,372,443,588,356,774,888,179], function() { return __webpack_exec__(11883); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);